import wrapperHOC from "@Utils/wrapperHOC";
import PopularProperties from ".";

interface PopularPropertiesSectionProps {
  gtagEventCategory: string;
  isDesktop?: boolean;
}

const PopularPropertiesSection = ({
  gtagEventCategory,
  isDesktop = false,
}: PopularPropertiesSectionProps) => (
  <PopularProperties gtagEventCategory={gtagEventCategory} isDesktop={isDesktop} />
);

export default wrapperHOC(PopularPropertiesSection, {
  componentName: "PopularPropertiesSection-SearchPage",
  showForChina: true,
  showForWhiteLable: true,
});
